module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/przebieg@2x-9f92f71b.png";